import i18n from "i18next";
import {CheckIcon} from "@heroicons/react/16/solid";
import {Link} from "react-router-dom";
import {generateLanguageLink, getCountryFlagByLanguage} from "@/utils/LanguageUtils";
import React, {useContext} from "react";
import {SettingsContext} from "@/SettingsContext";


const LanguageSwitcher =({borderColor}) => {


    const { tourSettings } = useContext(SettingsContext);

    /**
     * Duplicate in Home.js
     * @param hex
     * @param alpha
     * @returns {string}
     */
    function hexToRGB(hex, alpha) {
        if (hex) {
            let r = parseInt(hex.slice(1, 3), 16),
                g = parseInt(hex.slice(3, 5), 16),
                b = parseInt(hex.slice(5, 7), 16);

            if (alpha) {
                return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
            } else {
                return "rgb(" + r + ", " + g + ", " + b + ")";
            }
        }
    }

    return (<div>
        {(tourSettings.languages?.length > 1) &&
            <>

                <div className=" relative overflow-x-auto hide-scrollbar">
                    <div
                        className={`flex my-4 ${tourSettings.languages.length === 2 || tourSettings.languages.length < 3 ? 'justify-center' : ''} `}
                        style={{
                            width: tourSettings.languages.length >= 3 ? 'auto' : '100%',
                        }}
                    >
                        {tourSettings.languages.map((item, index) => (

                            <div key={index} className={`relative`} >
                                {i18n.language === item.code && <div
                                    className={`absolute ${index + 1 === tourSettings.languages.length ? 'right-1' : 'right-5'}  -top-2 w-5 h-5 p-0.5 rounded-full bg-white z-10`}>
                                    <CheckIcon className={`w-4 h-4 text-black`}/>
                                </div>}
                                <div className={`relative ${tourSettings.languages.length > 3 ? 'w-[20vw]' : 'w-[calc(33.333vw-2rem)]'} ${index !== tourSettings.languages.length - 1 ? 'mr-4' : ''}`} >
                                    <Link to={generateLanguageLink(item.code, location.pathname)}>
                                <div
                                    className={`absolute w-full h-12 border rounded-full ${(i18n.language === item.code) ? 'opacity-100' : 'opacity-30'} `}
                                    style={{
                                        backgroundColor: `${i18n.language === item.code ? hexToRGB('#ffffff', 0.1) : ''}`,
                                        borderColor: `${(borderColor) ? borderColor : '#000000'}`
                                    }}>
                                </div>
                                    <div className={`w-full h-8 py-1 text-center items-center`}>
                                            <div className="text-sm my-1 mx-auto rounded-full border border-white h-8 w-8 overflow-hidden relative">
                                                <div
                                                    className="absolute w-12 h-8 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-500">
                                                    {getCountryFlagByLanguage(item.code)}
                                                </div>
                                            </div>

                                    </div>

                                </Link>
                                </div>

                            </div>
                        ))}
                    </div>

                </div>
            </>
        }
    </div>);
}

export default LanguageSwitcher;